import React from 'react';
import propTypes from 'prop-types';

import { getMessage } from 'util/locale';
import { Label } from '@tcc/crate';
import { sortBy } from 'lodash';

const cssBasename = 'vra-application-script-card-product-list';
import { qaChemicalIds, prodChemicalIds } from 'constants/activities';
const entries = [...Object.entries(prodChemicalIds), ...Object.entries(qaChemicalIds)];
const chemicalTypeIdFromUUID = Object.fromEntries(entries.map(kv => [kv[1], kv[0]]));

function chemicalTypeNameFromUUID(chemicalTypeUUID) {
  const chemicalTypeId = chemicalTypeIdFromUUID[chemicalTypeUUID];
  return getMessage(`label-text__product-${chemicalTypeId}`);
}

const ApplicationScriptCardProductList = ({
  applicationProducts
}) => {

  applicationProducts.forEach(ap => {
    ap.chemicalTypeName = chemicalTypeNameFromUUID(ap.chemicalTypeId);
  });
  const sortedApplicationProducts = sortBy(applicationProducts, ['chemicalTypeName', 'name']);

  return (
    <div className={`${cssBasename}-background`}>
      <div className={`${cssBasename}-box`}>
        {sortedApplicationProducts.map(ap => (
          <div className={`${cssBasename}-item`} key={ap.id}>
            <div className={`${cssBasename}-item-header`}>
              {ap.name} {ap.isCustom && <Label className='custom-chemical-nested-badge' status='default'>
                {getMessage('text__use-custom-label-abbrev')}
              </Label> }
            </div>
            <span className={`${cssBasename}-item-secondary`}>
              {ap.chemicalTypeName} - {ap.isCustom ? getMessage('text__use-custom-label') : ap.company}
            </span>
          </div>
        ))}
      </div>
    </div>
  );

};

ApplicationScriptCardProductList.propTypes = {
  applicationProducts: propTypes.array.isRequired
};

export default ApplicationScriptCardProductList;
